export function formatAutomatedReportStatus(displayText, rawStatus, fallbackText) {
  if (displayText) {
    return displayText;
  }

  if (rawStatus) {
    return rawStatus;
  }

  return fallbackText;
}

export function normaliseAutomatedReportContent(content) {
  return content || "";
}
